import { render, staticRenderFns } from "./TextShimmer.vue?vue&type=template&id=8f95609e&"
import script from "./TextShimmer.vue?vue&type=script&lang=js&"
export * from "./TextShimmer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports